__turbopack_context__.v({
  "container": "index-module__S4DQQa__container",
  "dropzone": "index-module__S4DQQa__dropzone",
  "empty": "index-module__S4DQQa__empty",
  "heading": "index-module__S4DQQa__heading",
  "hint": "index-module__S4DQQa__hint",
  "item": "index-module__S4DQQa__item",
  "list": "index-module__S4DQQa__list",
});
